var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DocumentHeader',{attrs:{"header":"ใบส่งคืนสินค้า(ลดหนี้แล้ว)","link_back":"stock/document/documentreducedebt"}}),_c('document_reduce_details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }